import { Amplify } from 'aws-amplify';
import config from '../aws-exports';
import { useCallback, useEffect, useState } from 'react';

import "@aws-amplify/ui-react/styles.css";
import {
    withAuthenticator,
    Button,
    Heading,
    Image,
    View,
    Card,
} from "@aws-amplify/ui-react";

import { Row, Col, Container } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

import {
    SecretsManagerClient,
    GetSecretValueCommand,
} from "@aws-sdk/client-secrets-manager";

import { Storage } from "@aws-amplify/storage";


Amplify.configure(config);

function Orders({ signOut }) {

    const [allOrders, setAllOrders] = useState();
    const [filteredOrders, setFilteredorders] = useState();
    const [activeLink, setActiveLink] = useState("new");

    function getAllOrders() {
        var myHeaders = new Headers();
        myHeaders.append("x-api-key", "da2-y6osasbopbfgpppa7h6rmiipza");
        myHeaders.append("Content-Type", "application/json");

        var graphql = JSON.stringify({
            query: "query ListOrders {\r\n  listZeeepyOrders {\r\n    items {\r\n      additionalDetails\r\n      amount\r\n      assignedTo\r\n      createdAt\r\n      currency\r\n      custName\r\n      docType\r\n      email\r\n      id\r\n      isCompleted\r\n      langFrom\r\n      langTo\r\n      pageCount\r\n      orderAccepted\r\n      paymentStatus\r\n      payment_mode\r\n      phone\r\n      updatedAt\r\n      uploadedFile\r\n      wordCount\r\n    }\r\n  }\r\n}\r\n",
            variables: {}
        })
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: graphql,
            redirect: 'follow'
        };

        fetch("https://jqicdf3rkrcs7gesue3flieeru.appsync-api.eu-north-1.amazonaws.com/graphql?additionalDetails", requestOptions)
            .then(response => response.json())
            .then(result => {
                setAllOrders(result.data.listZeeepyOrders.items);
                setFilteredorders(result.data.listZeeepyOrders.items);
                console.log(result.data.listZeeepyOrders.items);
            })
            .catch(error => console.log('error', error));
    }

    //Show filtered orders - new/active/closed/cancelled
    function filterOrders(orderType){
        let filteredOrder = filteredOrders.filter((item)=>item.isCompleted===orderType);
        setAllOrders(filteredOrder);
        setActiveLink(orderType);
    }

    useEffect(() => {
        getAllOrders();
        
    }, [])

    const downloadFile = async (filename) => {
        try {
          const url = await Storage.get(filename);
          window.open(url);
        } catch (error) {
          console.error('Error downloading file:', error);
        }
    };
    

    const handleDownload = (fileName) => {
        downloadFile(fileName);
      };

    return (
        <>
            <div className='orders-list'>
                <button onClick={handleDownload}>Download</button>
                <Container>
                    <Navbar>
                        {/* <button onClick={uploadFile}>Upload </button> */}
                        <Container>
                            <Navbar.Brand href="#home" style={{ fontWeight: 600 }}>Dashboard</Navbar.Brand>
                            <Navbar.Toggle />
                            <Navbar.Collapse className="justify-content-left">
                                <Nav.Link className={activeLink==="new"?"active":""}  style={{ marginLeft: "20px" }} onClick={()=>filterOrders("new")}>New Orders</Nav.Link>
                                <Nav.Link className={activeLink==="active"?"active":""}  style={{ marginLeft: "20px" }} onClick={()=>filterOrders("active")}>Active Orders</Nav.Link>
                                <Nav.Link className={activeLink==="closed"?"active":""}  style={{ marginLeft: "20px" }} onClick={()=>filterOrders("closed")}>Closed Orders</Nav.Link>
                                <Nav.Link className={activeLink==="cancelled"?"active":""}  style={{ marginLeft: "20px" }} onClick={()=>filterOrders("cancelled")}>Cancelled Orders</Nav.Link>
                            </Navbar.Collapse>
                            <Navbar.Collapse className="justify-content-end">
                                <Navbar.Text>
                                    Signed in as: <a href="#login">Mark Otto</a>
                                </Navbar.Text>

                                <Nav.Link style={{ marginLeft: "20px", color: "red" }} onClick={signOut} >Logout</Nav.Link>
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>

                    <Row>
                        {allOrders !== undefined ? allOrders.map((item, ind) => {
                            return (
                                
                                    <Col md={4} key={ind}>
                                        <div className='order-container'>
                                            <table className='table table-borderless'>
                                                <tbody>
                                                    <tr>
                                                        <td className='cust-name' style={{ textAlign: "center" }} colSpan={2}>{item.custName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Order Id:</th>
                                                        <td>#{item.id}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Page Count:</th>
                                                        <td>{item.pageCount}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Word Count:</th>
                                                        <td>{item.wordCount}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Document Type:</th>
                                                        <td>{item.docType}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Email:</th>
                                                        <td>{item.email}</td>
                                                    </tr>

                                                    <tr>
                                                        <th>Phone:</th>
                                                        <td>{item.phone}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Language From:</th>
                                                        <td>{item.langFrom}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Language To:</th>
                                                        <td>{item.langTo}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Additional Details:</th>
                                                        <td>{item.additionalDetails}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Uploaded File:</th>
                                                        <td><button className='btn btn-danger' onClick={()=>handleDownload(item.uploadedFile)}>Download Document</button></td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={2}><hr></hr></td>
                                                    </tr>
                                                    <tr>
                                                        <th>Order Status:</th>
                                                        <td>{item.isCompleted}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Project Invoice:</th>
                                                        <td>{item.amount} <b>{item.currency}</b></td>
                                                    </tr>
                                                    <tr>
                                                        <th>Payment Status:</th>
                                                        <td>{item.paymentStatus}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Assigned To:</th>
                                                        <td>{item.assignedTo}</td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                        </div>

                                    </Col> 
                            )
                        }):""}
                    </Row>
                </Container>

            </div>
        </>
    );
}

export default withAuthenticator(Orders);